var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTruck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "6 10 19 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.5 17.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m10.043 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M24 18h.5v1h-1.457c0-1.38-1.12-2.5-2.5-2.5a2.5 2.5 0 0 0-2.5 2.5H13c0-1.38-1.122-2.5-2.5-2.5A2.5 2.5 0 0 0 8 19H6v-1h.5v-8h10v6h1v-4H21l3 3zm-4.5-3h3.086l-2-2H19.5z"
})));
export default SvgTruck;